import axiosInstance from 'core/network/axiosInstance'

export interface PayerSummaryApi {
  id: string
  name: string
  business_name?: string
  phone: string
  email?: string
  role: string
}

export interface EnrichedPaymentApi {
  id: string
  order_id: string
  payer?: PayerSummaryApi
  amount: number
  payment_date?: string
  payment_mode: string
  qr_ref?: string
  screenshot_url?: string
  status: string
  verified_by?: string
  verified_at?: string
  rejection_reason?: string
  created_at: string
  updated_at: string
}

export interface PaymentDetailApi extends EnrichedPaymentApi {
  payer_address?: string
}

export interface EnrichedPaymentListApiResponse {
  skip: number
  limit: number
  total: number
  data: EnrichedPaymentApi[]
}

export interface GetPaymentsApiParams {
  skip: number
  limit: number
  status?: string
  search?: string
}

export interface RejectPaymentApiRequest {
  reason: string
}

export interface UploadPaymentApiRequest {
  order_id: string
  amount: number
  payment_mode: string
  qr_ref?: string
  screenshot_url?: string
}

class PaymentApiDatasource {
  async getPaymentsEnriched(params: GetPaymentsApiParams): Promise<EnrichedPaymentListApiResponse> {
    const { data } = await axiosInstance.get<EnrichedPaymentListApiResponse>('/api/v1/payments/enriched', { params })
    return data
  }

  async getPaymentDetail(id: string): Promise<PaymentDetailApi> {
    const { data } = await axiosInstance.get<PaymentDetailApi>(`/api/v1/payments/${id}/detail`)
    return data
  }

  async uploadPayment(payload: UploadPaymentApiRequest): Promise<EnrichedPaymentApi> {
    const { data } = await axiosInstance.post<EnrichedPaymentApi>('/api/v1/payments', payload)
    return data
  }

  async verifyPayment(id: string): Promise<EnrichedPaymentApi> {
    const { data } = await axiosInstance.patch<EnrichedPaymentApi>(`/api/v1/payments/${id}/verify`)
    return data
  }

  async rejectPayment(id: string, payload: RejectPaymentApiRequest): Promise<EnrichedPaymentApi> {
    const { data } = await axiosInstance.patch<EnrichedPaymentApi>(`/api/v1/payments/${id}/reject`, payload)
    return data
  }
}

export const paymentApiDatasource = new PaymentApiDatasource()
